import React from "react";
import Chart from "react-apexcharts";

const BalanceSheetChart = ({ data }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="bg-white p-10 text-center rounded-2xl border border-dashed border-gray-200 text-gray-400">
        No balance sheet data available.
      </div>
    );
  }

  const barConfig = {
    series: [
      {
        name: "Income",
        data: data.map(item => Number(item.totalIncome || 0)),
      },
      {
        name: "Expense",
        data: data.map(item => Number(item.totalExpense || 0)),
      },
    ],
    options: {
      chart: { type: "bar", toolbar: { show: false } },
      xaxis: { categories: data.map(item => item.month) },
      colors: ["#10B981", "#EF4444"],
      plotOptions: {
        bar: { borderRadius: 6, columnWidth: "45%" },
      },
      dataLabels: { enabled: false },
      legend: { position: "top" },
      tooltip: {
        y: { formatter: val => `₹${Number(val).toLocaleString()}` },
      },
    },
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8">
      <p className="text-sm font-bold text-gray-600 uppercase mb-4">
        Monthly Balance Sheet Trend
      </p>
      <Chart
        options={barConfig.options}
        series={barConfig.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default BalanceSheetChart;
